module.exports = __webpack_public_path__ + "img/yellow-lily.401cd25b.webp";